import React, { useCallback } from 'react';

import Select from 'react-select';

const withOptionsSelect = (options) => {
   return ({
      className: propsClassName = '',
      value,
      defaultValue = {},
      ...props
   }) => {
      const handleChange = useCallback((selectedOption) => {
         if (props.onChange) {
            props.onChange(selectedOption);
         }
      }, [props.onChange]);

      return (
         <Select
            value={ value }
            className={ `react-select-container ${ propsClassName }` }
            classNamePrefix='react-select'
            onChange={ handleChange }
            options={ options }
            defaultValue={ defaultValue }
         />
      );
   };
};

export default withOptionsSelect;
